import { SingingPortraitFragment } from 'api/contentful/contentful.graphql.types'
import { Button } from 'components/button/Button'
import { ThemedTextImageSection } from 'components/content/themedTextImageSection/ThemedTextImageSection'
import { Icon } from 'components/icon'
import { Text } from 'components/Typography'
import { VideoCarousel } from 'components/videoCarousel/VideoCarousel'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

export type StoryPortraitsLandingPageSectionProps = {
  storyPortraitAnimations: SingingPortraitFragment[]
}

export const StoryPortraitsLandingPageSection: FC<StoryPortraitsLandingPageSectionProps> = (
  props
) => {
  const { t } = useTranslation('life_stories')
  return (
    <ThemedTextImageSection
      title={t('life_stories.section_story_portraits.title')}
      image={<VideoCarousel items={props.storyPortraitAnimations} />}
      imagePlacement="right"
    >
      <Text>{t('life_stories.section_story_portraits.description')}</Text>
      <Button
        type="button"
        leftIcon={<Icon name="Voice" />}
        variant="text"
        size="large"
        href="/story-portraits"
        renderAsButton
      >
        {t('life_stories.section_story_portraits.cta')}
      </Button>
    </ThemedTextImageSection>
  )
}
